/**
 * Project - fasthelp5.fa2chat-product
 *
 * @desc 注意事項ダイアログ
 *
 * @author keokamoto
 * @copyright Copyright 2018 TechMatrix Corporation, Inc. All rights reserved.
 */
<template>
<transition name="modal">
  <div class="fc-chat-caution-confirm-dialog">
    <div class="modal-wrapper">
      <div class="modal-container">
        <div class="modal-header">
          {{cautionMessage}}
        </div>
        <div class="bot-confirm-body">
          <el-button type="primary" @click="startBotChat">{{botStartButton}}</el-button>
          <el-button @click="cancelBotChat">{{botCancelButton}}</el-button>
        </div>
      </div>
    </div>
  </div>
</transition>
</template>

<script>
import {
  Button
} from 'element-ui'

export default {
  components: {
    'el-button': Button
  },
  data() {
    return {
      /**
       * 確認メッセージ
       * @type {Object}
       */
      cautionMessage: null,
      /**
       * BOT開始ボタン
       * @type {Object}
       */
      botStartButton: null,
      /**
       * BOTキャンセルボタン
       * @type {Object}
       */
      botCancelButton: null
    }
  },
  methods: {
    /**
     *  Bot画面に移動する
     */
    startBotChat() {
      this.$emit('cautionBotStart')
    },
    /**
     *  やめる
     */
    cancelBotChat() {
      this.$emit('cautionNoBotStart')
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/chatWindow/chatMain/dialog/FcChatCautionConfirmDialog.vue